import type { MouseEvent } from 'react';
import { type NavigateFunction, useNavigate } from 'react-router-dom';
import { isPlainLeftClick } from '../utils/isPlainLeftClick';

type LinkClickHandler = (event: MouseEvent<HTMLElement>) => void;

/**
 * Click handler for an `<a href>` rendered by the design system: plain clicks
 * go through the router (no full page reload), modified clicks keep the
 * native behaviour (new tab, new window, download).
 */
export function createRouterLinkClickHandler(
  navigate: NavigateFunction,
  targetUrl: string,
  onClick?: LinkClickHandler,
): LinkClickHandler {
  return (event) => {
    event.stopPropagation();
    onClick?.(event);
    if (!isPlainLeftClick(event)) {
      return;
    }
    event.preventDefault();
    navigate(targetUrl);
  };
}

export function useRouterLinkClick(targetUrl: string, onClick?: LinkClickHandler): LinkClickHandler {
  const navigate = useNavigate();
  return createRouterLinkClickHandler(navigate, targetUrl, onClick);
}
